import React, { useEffect, useState } from "react"
import { Row, Col, Form, Table } from "react-bootstrap"
import SelectedGovPanel from "../../api/Randoms/GovPoolModel/GovPerformCollection"
import { Dictionary } from "../../api/GovPerformCollection/Dictionary"

export interface AdditionalPanelsProps {
  panels: Dictionary<SelectedGovPanel>
  onUpdate: (panels: Dictionary<SelectedGovPanel>) => void
}

const AdditionalPanels = (props: AdditionalPanelsProps) => {
  const { onUpdate } = props

  const [panels, setPanels] = useState<Dictionary<SelectedGovPanel>>(props.panels)

  const formatDrugLabel = (label: string) => {
    const mappings = [{ from: " CONF URN", to: "" }].forEach((m) => (label = label.replace(m.from, m.to)))

    return label
  }

  const onSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const code = e.target.value
    const checked = e.target.checked ? 1 : 0

    setPanels((prev) => ({ ...prev, [code]: { ...prev[code], SendToLab: checked } }))
  }

  useEffect(() => {
    setPanels(props.panels)
  }, [props.panels])

  useEffect(() => {
    onUpdate(panels)
  }, [onUpdate, panels])

  return (
    <>
      {Object.values(panels).length > 0 && (
        <Row className="pt-3">
          <Col>
            <h6 className="ml-3">Additional Testing</h6>
            <Table striped bordered hover responsive className="m-0">
              <tbody>
                {Object.values(panels).map((panel, code) => (
                  <tr key={`adpanel_${code}`}>
                    <td>
                      <Form.Check
                        //inline
                        id={`adpanel_${code}`}
                        type="checkbox"
                        value={panel.Code}
                        label={formatDrugLabel(panel.Name)
                          /*panel.ExternalID !== ""
                            ? formatDrugLabel(panel.Name)
                            : `${formatDrugLabel(panel.Name)} (Not Available)`*/
                        }
                        checked={panel.SendToLab === 1}
                        //disabled={panel.ExternalID === ""}
                        onChange={onSelect}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      )}
    </>
  )
}

export default AdditionalPanels
